var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPunchOut = function SvgPunchOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#punchOut_svg__a)",
    stroke: "#1A1E2C",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.376 15.531-5.431 5.431M4.133 15.531h4.243v4.243M8.377 8.432 2.946 3M8.377 4.19v4.242H4.135M15.452 15.522l5.433 5.434M15.452 19.765v-4.243h4.243M15.43 8.455l5.433-5.432M19.673 8.455h-4.242V4.213"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "punchOut_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgPunchOut;